import request from '../../request';
import { HierarchyType } from 'services/resources';

// eslint-disable-next-line import/prefer-default-export
export function updateUserLocale(userId: number, languageId: string) {
  return request(`common/profiles/${userId}/`, {
    method: 'PATCH',
    data: {
      language: languageId,
    },
    params: {
      acting_as: HierarchyType.SELF,
    },
  });
}
